import { userConstants } from "../../constant";

const initialState = {
  buyerQuotes: [],
  sellerQuotes: [],
};

export function quoteRequests(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_BUYER_QUOTES:
      return { ...state, buyerQuotes: action.quotes };

    case userConstants.GET_SELLER_QUOTES:
      return { ...state, sellerQuotes: action.quotes };

    case userConstants.SUBMIT_QUOTE_REQUEST:
      return {
        ...state,
        buyerQuotes: [action.quote, ...state.buyerQuotes],
      };

    case userConstants.RESPOND_TO_QUOTE: {
      const updated = action.quote;
      return {
        ...state,
        buyerQuotes: state.buyerQuotes.map((q) =>
          q.id === updated.id ? updated : q
        ),
        sellerQuotes: state.sellerQuotes.map((q) =>
          q.id === updated.id ? updated : q
        ),
      };
    }

    default:
      return state;
  }
}
